import { GlobalConfig } from "ngx-toastr";
import { ThemeTitles } from "../enums/app.enums";
import { ThemeData } from "../models/models";

export const ToastrConfig: Partial<GlobalConfig> = {
    iconClasses: {
        error: 'err-msg',
        info: 'info-msg',
        success: 'success-msg',
        warning: 'warning-msg'
    },
    closeButton: true
}

export const ModalAttributes = {
    "aria-haspopup": "dialog",
    "aria-expanded": false,
    "aria-controls": "hs-vertically-centered-scrollable-modal",
    "data-hs-overlay": "#hs-vertically-centered-scrollable-modal",
    "id": "hs-large-modal"
}

export const AgeRangeConfig = { floor: 18, ceil: 65, hidePointerLabels: true, hideLimitLabels: true };
export const ExpRangeConfig = { floor: 0, ceil: 30, hidePointerLabels: true, hideLimitLabels: true };
export const SalaryRangeConfig = { floor: 5000, ceil: 300000, hidePointerLabels: true, hideLimitLabels: true };
export const JobCountRangeConfig = { floor: 0, ceil: 50, hidePointerLabels: true, hideLimitLabels: true };

export const PageTitle = {
    mobile: 'Jobs',
    tablet: 'Job Search',
    laptop: 'Find Your Next Job',
    desktop: 'Professional Job Search Platform',
    default: 'Jobs'
}

export const SALARY_PERCENTAGE = {
    MAX_SALARY_FROM_MIN_MULTIPLIER: 1.3, // +30%
    EXCEED_MARGIN_MULTIPLIER: 1.2        // +20%
};

export const SALARY_ERROR_MESSAGES = {
    MIN: 'Expected salary must be at least 1000.',
    MAX: 'Expected salary must not exceed 9999999.',
}

export const PROMO_MODAL_SHOW = 'promo-modal-shown'
export const HOME_MODAL_HIDDEN = 'isHomeModalHidden'

export const UPDATE_CV_ERROR_MESSAGE = 'You have not updated your resume for more than 3 months.'
export const JOB_NOT_AVAILABLE_ERROR_MESSAGE = 'The job you are trying to apply is not available now!'

export const FavSearchLimitReachedMsgEn = 'Limit reached! Please remove an existing filter before adding a new one.';
export const FavSearchLimitReachedMsgBn = 'ফিল্টারের লিমিট শেষ! নতুন ফিল্টার যোগ করতে পুরনো একটি মুছে ফেলুন।';

export const FavSearchSuccessMssgEn = 'Your search criteria has been inserted successfully';
export const FavSearchSuccessMssgBn = 'আপনার সার্চ ক্রাইটেরিয়া সফলভাবে সেভ করা হয়েছে।';

export const FavSearchErrorEn = 'Couldn’t save your filter. Please try again.';
export const FavSearchErrorBn = 'আপনার ফিল্টার সংরক্ষণ করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।';

export const FaveSearchDuplicateEn = "Filter name already exists! Please choose a different name to save your filter."
export const FavSearchDuplicateBn = "ফিল্টারের নাম ইতিমধ্যেই ব্যবহার করা হয়েছে! আপনার ফিল্টার সেভ করতে ভিন্ন একটি নাম নির্বাচন করুন।"

export const EarlyAccessModalEn = "You are not eligible for this feature!"
export const EarlyAccessModalBn = "ফিচারটি আপনার জন্য প্রযোজ্য নয়!"
export const CANNOT_UNDO_ERROR_MSG ='Application cannot be undone because it has an ongoing conversation.'

export const InvalidEventResponseType = 2;
export const NotificationType = 'all';

export const SuccessEventType = 1;

export const FilterThemeRecord: Record<ThemeTitles, ThemeData> = {
  'blue' : {
    bgPrimaryColor: 'bg-[#0E73A9]',
    bgSecondaryColor: 'bg-white',
    hoverBgPrimaryColor: 'bg-white',
    hoverBgSecondaryColor: 'bg-[#0E73A9]',
    borderPrimaryColor: 'border-[#0E73A9]',
    borderSecondaryColor: 'border-white',
    hoverBorderPrimaryColor: 'border-white',
    hoverBorderSecondaryColor: 'border-[#0E73A9]',
    textPrimaryColor: 'text-[#344054]',
    textSecondaryColor: 'text-white',
    hoverTextPrimaryColor: 'text-white',
    hoverTextSecondaryColor: 'text-[#0E73A9]',
    placeholderPrimaryColor: 'placeholder:text-[#0E73A9]',
    placeholderSecondaryColor: 'placeholder:text-[#424242]',
    hoverPlaceholderPrimaryColor: '',
    hoverPlaceholderSecondaryColor: '',
  },
  'pink' : {
    bgPrimaryColor: 'bg-[#C63C92]',
    bgSecondaryColor: 'bg-white',
    hoverBgPrimaryColor: 'bg-white',
    hoverBgSecondaryColor: 'bg-[#C63C92]',
    borderPrimaryColor: 'border-[#C63C92]',
    borderSecondaryColor: 'border-white',
    hoverBorderPrimaryColor: 'border-white',
    hoverBorderSecondaryColor: 'border-[#C63C92]',
    textPrimaryColor: 'text-[#344054]',
    textSecondaryColor: 'text-white',
    hoverTextPrimaryColor: 'text-white',
    hoverTextSecondaryColor: 'text-[#C63C92]',
    placeholderPrimaryColor: 'placeholder:text-[#C63C92]',
    placeholderSecondaryColor: 'placeholder:text-[#424242]',
    hoverPlaceholderPrimaryColor: '',
    hoverPlaceholderSecondaryColor: '',
  },
  'gray' : {
    bgPrimaryColor: 'bg-[#0E73A9]',
    bgSecondaryColor: 'bg-[#0E73A9]',
    hoverBgPrimaryColor: 'bg-[#0E73A9]',
    hoverBgSecondaryColor: 'bg-[#0E73A9]',
    borderPrimaryColor: '',
    borderSecondaryColor: '',
    hoverBorderPrimaryColor: '',
    hoverBorderSecondaryColor: '',
    textPrimaryColor: '',
    textSecondaryColor: '',
    hoverTextPrimaryColor: '',
    hoverTextSecondaryColor: 'text-[#667085]',
    placeholderPrimaryColor: '',
    placeholderSecondaryColor: '',
    hoverPlaceholderPrimaryColor: '',
    hoverPlaceholderSecondaryColor: '',
  },
}
